var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 0.125H2.6875C2.10753 0.12562 1.55149 0.356288 1.14139 0.766389C0.731288 1.17649 0.50062 1.73253 0.5 2.3125V11.6875C0.50062 12.2675 0.731288 12.8235 1.14139 13.2336C1.55149 13.6437 2.10753 13.8744 2.6875 13.875H15.8125C16.3925 13.8744 16.9485 13.6437 17.3586 13.2336C17.7687 12.8235 17.9994 12.2675 18 11.6875V2.3125C17.9994 1.73253 17.7687 1.17649 17.3586 0.766389C16.9485 0.356288 16.3925 0.12562 15.8125 0.125V0.125ZM15.2586 3.74336L9.63359 8.11836C9.52391 8.20363 9.38893 8.24992 9.25 8.24992C9.11107 8.24992 8.97609 8.20363 8.86641 8.11836L3.24141 3.74336C3.17532 3.69345 3.11981 3.63091 3.0781 3.55936C3.03639 3.48781 3.00932 3.40869 2.99846 3.32659C2.98759 3.24449 2.99315 3.16104 3.01482 3.08111C3.03648 3.00118 3.07381 2.92635 3.12465 2.86097C3.17548 2.79559 3.2388 2.74096 3.31093 2.70027C3.38306 2.65957 3.46255 2.63362 3.5448 2.62391C3.62704 2.6142 3.7104 2.62094 3.79002 2.64372C3.86964 2.66651 3.94394 2.70489 4.00859 2.75664L9.25 6.8332L14.4914 2.75664C14.6225 2.65766 14.7872 2.61426 14.95 2.6358C15.1129 2.65734 15.2607 2.74211 15.3615 2.87177C15.4623 3.00142 15.508 3.16555 15.4887 3.32866C15.4695 3.49176 15.3868 3.64073 15.2586 3.74336Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7796c6e673c1987794a68233ced00365.svg";
export { ForwardRef as ReactComponent };